import React from 'react';
import { ArrowRight, Linkedin, Instagram, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nProvider';
import SignUpLink from './SignUpLink';
import { FooterLogo } from './BookersLogo';

export function CTASection() {
  const { t } = useI18n();
  return (
    <section id="contact" className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
      <div className="reveal relative overflow-hidden rounded-[2.5rem] bg-pastel-soft border border-black/5 px-8 py-16 md:py-24 text-center">
        <p className="text-sm font-semibold text-brand-dark">{t('cta.eyebrow')}</p>
        <h2 className="font-display text-4xl md:text-6xl mt-3 max-w-3xl mx-auto text-[#0b0b0f]">{t('cta.title')}</h2>
        <p className="text-[#55555f] mt-4 text-lg max-w-xl mx-auto">{t('cta.description')}</p>
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <SignUpLink className="btn-pill btn-brand px-8 py-3.5 text-[15px] group inline-flex items-center justify-center gap-2">
            {t('cta.signUpFree')} <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
          </SignUpLink>
          <Link to="/signup" className="btn-pill btn-light px-8 py-3.5 text-[15px] group inline-flex items-center justify-center gap-2" data-testid="book-demo-cta">
            {t('cta.bookDemo')} <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
        <p className="text-sm text-[#8b8b95] mt-5">{t('cta.footnote')}</p>
      </div>
    </section>
  );
}

export function Footer() {
  const { t } = useI18n();
  const cols = [
    { title: t('footer.product'), links: [
      { label: t('footer.features'), href: '/#features' },
      { label: t('footer.solutions'), href: '/solutions' },
      { label: t('footer.pricing'), href: '/pricing' },
      { label: t('footer.integrations'), href: '/#features' },
      { label: t('footer.ownerApp'), href: '/#features' },
    ]},
    { title: t('footer.company'), links: [
      { label: t('footer.about'), href: '/#services' },
      { label: t('footer.blog'), href: '#' },
      { label: t('footer.contact'), href: '/contact' },
      { label: t('footer.bookDemo'), href: '/signup' },
      { label: t('footer.partners'), href: '#' },
    ]},
    { title: t('footer.resources'), links: [
      { label: t('footer.helpCenter'), href: '#' },
      { label: t('footer.apiDocs'), href: '#' },
      { label: t('footer.status'), href: '#' },
      { label: t('footer.community'), href: '#' },
      { label: t('footer.webinars'), href: '#' },
    ]},
  ];
  return (
    <footer className="bg-[#0b0b0f] text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <FooterLogo />
            <p className="text-white/55 mt-4 max-w-xs text-[15px] leading-relaxed">{t('footer.tagline')}</p>
            <div className="flex gap-3 mt-6">
              {[Linkedin, Instagram, Twitter].map((Icon, i) => (
                <a key={i} href="#social" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/10 transition-colors">
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <p className="font-semibold text-[15px]">{c.title}</p>
              <ul className="mt-4 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}><Link to={l.href} className="text-white/55 hover:text-white transition-colors text-[15px]">{l.label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/45 text-sm">{t('footer.rights')}</p>
          <div className="flex items-center gap-6 text-sm text-white/45">
            <Link to="/terms" className="hover:text-white transition-colors">{t('footer.terms')}</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">{t('footer.privacy')}</Link>
            <Link to="/cookie-policy" className="hover:text-white transition-colors">{t('footer.cookies')}</Link>
            <span>{t('footer.madeFor')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
